module.exports = __webpack_public_path__ + "img/talron-qna-minus.86d94b1b.svg";